module.exports = __webpack_public_path__ + "static/media/boom.bd8f2249.svg";